import { Constants } from "../Constants";

export class mapsApi{

	baseApiString = "https://dev.virtualearth.net/REST/v1/Autosuggest?query="

	getAutoSuggestValues(requestString, apiKey){
		var encodedRequest = encodeURI(requestString);
		var apiRequestString = this.baseApiString + encodedRequest + "&key=" + apiKey; // TODO: Replace this with a call to the backend
		
		return fetch(apiRequestString)
			.then(response => response.json())
			.then(data => data.resourceSets[0].resources[0].value[0].address);
	}
}
			
